// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton-module__closeButton___H-X3f"};